// Constants for different requests for current reducer
export default {
  accountInfo: 'ACCOUNT_INFO',
};
